import React from "react";

import "./Maintenance.css";

import NavLogo from "@assets/logos/nav-logo4.svg?react";

const STATUS_PAGE_URL = "https://nco-dashboard.statusgator.app/";

export default function Maintenance({onRetry, retrying = false}) {
    return (
        <div className="maintenance-page">
            <NavLogo className="maintenance-logo"/>

            <h1 className="maintenance-title">
                The NetCyberOps Portal is temporarily unavailable. Check our status page for updates.
            </h1>

            <div className="maintenance-actions">
                <button
                    type="button"
                    className="maintenance-btn maintenance-btn-primary"
                    onClick={onRetry}
                    disabled={retrying}
                    id="maintenance-retry-btn"
                >
                    {retrying ? "Retrying..." : "Retry"}
                </button>
                <a
                    className="maintenance-btn maintenance-btn-ghost"
                    href={STATUS_PAGE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    id="maintenance-status-btn"
                >
                    Go to status page
                </a>
            </div>
        </div>
    );
}
